export const SUPPORT_TICKET_CREATED_EVENT = 'ss-support-ticket-created';

export function dispatchSupportTicketCreated(ticketId) {
  if (typeof window === 'undefined' || !ticketId) return;
  window.dispatchEvent(
    new CustomEvent(SUPPORT_TICKET_CREATED_EVENT, { detail: { ticketId } }),
  );
}
